// defaults
export const DEFAULT_PAGE_SIZE = 15;

// search domains
export const DOMAIN_APPS = 'apps';
export const DOMAIN_LIBRARY = 'library';
export const DOMAIN_GROUPS = 'groups';
export const DOMAIN_PEOPLE = 'people';
